import { clsx } from 'clsx'
import { STATUS_COLORS } from '@/lib/constants'

interface StatusBadgeProps {
  status: string
  children?: React.ReactNode
}

export function StatusBadge({ status, children }: StatusBadgeProps): React.JSX.Element {
  const colorClass =
    STATUS_COLORS[status as keyof typeof STATUS_COLORS] ?? 'bg-gray-100 text-gray-700'

  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize',
        colorClass,
      )}
    >
      {children ?? status.replace(/_/g, ' ')}
    </span>
  )
}
